/**
 *
 * Back To Top (JS)
 *
 * @author Space-Time Inc.
 *
 */


(function () {
	var scrollingElement = document.scrollingElement;

	var btt = document.getElementById('backtotop');
	if (btt === null) return;

	var footer = document.getElementsByClassName('site-footer')[0];
	var offsetY = 0;

	setTimeout(function () {
		var wpadminbar = document.getElementById('wpadminbar');
		offsetY = (wpadminbar) ? - wpadminbar.clientHeight : 0;
	}, 100);

	var placeTop = window.innerHeight / 3;
	function scrollFn() {
		if (window.pageYOffset > placeTop) {
			btt.classList.remove('hidden');
		} else {
			btt.classList.add('hidden');
		}
		var viewBottomY = scrollingElement.scrollTop + window.innerHeight + offsetY;

		if (viewBottomY > footer.offsetTop + 48) {
			btt.style.transform = 'translateY(-' + (viewBottomY - footer.offsetTop) + 'px)';
		} else {
			btt.style.transform = 'translateY(-48px)';
		}
	};

	window.BackToTopLib = window.BackToTopLib || {};
	window.BackToTopLib.scrollFn = scrollFn;

	window.addEventListener('scroll', scrollFn);
	if ('ontouchstart' in window) {
		window.addEventListener('touchmove', scrollFn);
	}
	scrollFn();
	window.addEventListener('resize', scrollFn);
})();
